module.exports = __webpack_public_path__ + "static/img/es.712c7aab.png";